import React, { ReactNode } from "react";
import "./EmptyState.css";

type EmptyStateType = "error" | "info" | "empty";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string | ReactNode;
  description?: string | ReactNode;
  action?: ReactNode;
  type?: EmptyStateType;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  type = "empty"
}) => {
  let iconFill = "#6b7280";

  if (type === "error") {
    iconFill = "#ef4444";
  } else if (type === "info") {
    iconFill = "#3b82f6";
  }

  // Clone the icon to inject the fill color
  const clonedIcon = React.isValidElement(icon)
    ? React.cloneElement(icon as React.ReactElement<any>, {
        style: { width: "2rem", height: "2rem", fill: iconFill, ...((icon.props as any).style || {}) }
      })
    : icon;

  return (
    <div className="empty_state_wrapper">
      {icon && (
        <div className={`empty_state_icon_wrapper empty_state_type_${type}`}>
          {clonedIcon}
        </div>
      )}
      
      <div className="empty_state_text_wrapper">
        <h2 className="empty_state_title">
          {title}
        </h2>
        
        {description && (
          <p className="empty_state_description">
            {description}
          </p>
        )}
      </div>

      {action && <div className="empty_state_action">{action}</div>}
    </div>
  );
};

export default EmptyState;
